module.exports = __webpack_public_path__ + "static/img/013.5ab5670.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/013.png
// module id = An1W
// module chunks = 0